export const errorMessages = {
    failedToLoadBasket: 'FAILED_TO_LOAD_BASKET' as const,
    cannotSetOlderBasket: 'CANNOT_SET_OLDER_BASKET' as const,
    productNotFound: 'PRODUCT_NOT_FOUND' as const,
    basketDestroyed: 'BASKET_DESTROYED' as const,
    asyncOperationCancelled: 'ASYNC_OPERATION_CANCELLED' as const
};
